var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import cuid from 'cuid';
import React from 'react';
import { BlockTypes } from '..';
import CmsImage from '../../Image';
import CustomScript from '../FooterCustomScript';
var BadgeWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 4rem;\n"], ["\n  height: 4rem;\n"])));
var FooterBlockBadges = function (_a) {
    var _b;
    var contentData = _a.contentData, _c = _a.uuid, uuid = _c === void 0 ? cuid() : _c;
    return (React.createElement("div", { className: BlockTypes.BlockBadges, "data-testid": BlockTypes.BlockBadges, key: BlockTypes.BlockBadges + "-" + uuid }, (_b = contentData === null || contentData === void 0 ? void 0 : contentData.paragraph) === null || _b === void 0 ? void 0 : _b.map(function (item) {
        var uuidBadge = cuid();
        var Badge = function () {
            switch (item.type) {
                case 'externalscript':
                    return React.createElement(CustomScript, { contentData: item, key: uuidBadge });
                case 'svg_file':
                case 'image_footer':
                    return React.createElement(CmsImage, { contentData: item, key: uuidBadge });
                default:
                    return React.createElement(React.Fragment, null);
            }
        };
        return (React.createElement(BadgeWrapper, null,
            React.createElement(Badge, null)));
    })));
};
export default FooterBlockBadges;
var templateObject_1;
//# sourceMappingURL=index.js.map